import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from 'src/components/ui/breadcrumb';
import { getAppType } from '../../../redux/appBuilder/stepperDetails/selectors';
import { useAppSelector } from '../../../redux/hooks';
import { SidebarTrigger } from 'src/components/ui/sidebar';
import { Separator } from 'src/components/ui/separator';

export const TopNavbar = () => {
  const appType = useAppSelector(getAppType);
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<{ name: string; path: string }[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const generateBreadcrumbs = () => {
      const pathSegments = location.pathname
        .split('/')
        .filter((segment) => segment !== '');
      const breadcrumbItems = pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
        let name =
          segment.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) || '';

        if (segment === 'new-application') {
          if (appType === 'WEB') {
            name = 'New Web App';
          } else if (appType === 'MOBILE') {
            name = 'New Mobile App';
          } else if (appType === 'ZK_FETCH') {
            name = 'New Zk Fetch';
          }
        }

        return { name, path };
      });
      setBreadcrumbs([{ name: 'Devtool', path: '/dashboard' }, ...breadcrumbItems]);
    };

    generateBreadcrumbs();
  }, [location, appType]);

  const handleBreadcrumbClick = (path: string) => {
    if (path.includes('edit-application')) {
      navigate('/my-applications');
    } else if (path.includes('code-preview') || path === '/admin') {
      return;
    } else if (path === '/provider-builder' && location.search === '?isEdit=true') {
      return;
    } else {
      navigate(path);
    }
  };

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs.map((item, index) => (
              <>
                <BreadcrumbItem key={index} className="hidden md:block">
                  {index === breadcrumbs.length - 1 ? (
                    <BreadcrumbPage>{item.name}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink
                      className="cursor-pointer"
                      onClick={() => {
                        handleBreadcrumbClick(item.path);
                      }}
                    >
                      {item.name}
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {index !== breadcrumbs.length - 1 && (
                  <BreadcrumbSeparator className="hidden md:block" />
                )}
              </>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </header>
  );
};
